(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["login"]) return;
  try {
    

// submit時の前処理
document.getElementById('login-submit-button').addEventListener('click', (e) => {

  // customerAccessTokenを作成
  const userState = new UserState();
  const graphQL = new GraphQL();

  const customer_email = $('#customer_email').val();
  const customer_password = $('#customer_password').val();

  graphQL.customerAccessTokenCreate({
    'email': customer_email,
    'password': customer_password
  })
    .then(function(response) {
      userState.setProperty('customer_access_token', response);
    })
    .catch((reason) => {
      console.log(reason);
    });

}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order"]) return;
  try {
    

/// order-editor-link前処理
document.getElementById('order-editor-link').addEventListener('click', () => {

  // order_id, address_idを取得
  const order_id = $('#order_id').val();
  const customer_address_id = $('#customer_address_id').val();

  // sessionStorageにorder_idを保持
  const userState = new UserState();
  userState.setProperty('last_reorder',
    {
      order_id: order_id,
      customer_address_id: customer_address_id
    });

}, true);

/// order-cancel-link前処理
document.getElementById('order-cancel-link').addEventListener('click', (event) => {
  // メール文面を作成
  let mailbody = 'キャンセル専用メールです。　そのまま送信ボタンを教えて下さい。%0D%0A';
  mailbody += '%0D%0A';
  mailbody += '---システム上の注文情報---%0D%0A';
  mailbody += '%0D%0A';

  // 注文詳細を取得
  const table = document.getElementsByClassName('account-order')[0];
  for (let row of table.tBodies[0].rows) {
    mailbody += row.cells[0].innerText;
    mailbody += ' 価格: ' + row.cells[1].innerText.replace('Translation missing: ja.product.item.price.current', '');
    mailbody += ' 数量: ' + row.cells[2].innerText;
    mailbody += ' 合計: ' + row.cells[3].innerText.replace('Translation missing: ja.product.item.price.current', '');
    mailbody += '%0D%0A';
  }

  // 合計を取得
  const total = document.getElementsByClassName('order-footer')[0];
  mailbody += '%0D%0A' + total.innerText.replace(/\n/g, '  ') + '%0D%0A';

  // Aタグに反映
  let mailto = event.target.href;
  event.target.href = mailto.replace('MAILBODY', mailbody);
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-cart"]) return;
  try {
    

const userState = new UserState();

// sessionStorageからorder_idを取り出す
const last_reorder = userState.getProperty('last_reorder');
userState.clearProperty('last_reorder'); // 取り出した後は削除しておく
if (last_reorder) {
  // プルダウンの選択をlast_reorderに
  $('#shipping_address').val(last_reorder.customer_address_id);
}

// 送り状に記載するメモの内容を貴社注文番号に書き写す
$('#to-copy-down').on('click', function(){
  var text = document.getElementsByName('attributes[送り状に記載するメモ]')[0].value;
  document.getElementsByName('attributes[貴社注文番号/現場名]')[0].value = text;
});

// 物流担当者へのメモ入力欄にフォーカスが当たったときの処理
document.getElementsByClassName('remarks_memo')[0].addEventListener('focus', (e) => {
  var inputVal = $('.remarks_memo').eq(0).val();

  // 文字列の頭に「新年度品　受注商品はまとめて同日に出荷してください。　」が含まれている場合
  if($('.remarks_memo').eq(0).val().indexOf("新年度品　受注商品はまとめて同日に出荷してください。　") == '0') {
    // 先頭の「新年度品　受注商品はまとめて同日に出荷してください。　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(27));
  }

  // 文字列の頭に「新年度品　」が含まれている場合
  if($('.remarks_memo').eq(0).val().indexOf("新年度品　") == '0') {
    // 先頭の「新年度品　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(5));
  }

  if($('.remarks_memo').eq(0).val().indexOf("受注商品はまとめて同日に出荷してください。　") == '0') {
    // 先頭の「受注商品はまとめて同日に出荷してください。　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(22));
  }
}, true);

// 入力文字数制限の通知
// 指定したinput要素に対し、maxlengthを超える入力をしようとした際にアラートを出して入力を止める
function setupMaxLengthAlert(selector, fieldName) {
  const el = document.querySelector(selector);
  if (!el) return;
  const max = parseInt(el.getAttribute('maxlength'), 10);
  if (!max) return;

  // 入力前にチェックして上限を超える場合は入力をキャンセル
  el.addEventListener('beforeinput', function(e) {
    // 削除系の操作はチェック対象外
    if (e.inputType && e.inputType.indexOf('delete') === 0) return;

    const cur = el.value;
    const selStart = el.selectionStart != null ? el.selectionStart : cur.length;
    const selEnd = el.selectionEnd != null ? el.selectionEnd : cur.length;
    const insertText = e.data != null ? e.data : '';
    const newLength = cur.length - (selEnd - selStart) + insertText.length;

    if (newLength > max) {
      e.preventDefault();
      alert(fieldName + 'は' + max + '文字まで入力可能です。');
    }
  });

  // 貼り付け時のフォールバック（beforeinput非対応ブラウザ向け）
  el.addEventListener('paste', function(e) {
    const clipboardData = e.clipboardData || window.clipboardData;
    if (!clipboardData) return;
    const pasteText = clipboardData.getData('text');
    const cur = el.value;
    const selStart = el.selectionStart != null ? el.selectionStart : cur.length;
    const selEnd = el.selectionEnd != null ? el.selectionEnd : cur.length;
    const newLength = cur.length - (selEnd - selStart) + pasteText.length;

    if (newLength > max) {
      e.preventDefault();
      alert(fieldName + 'は' + max + '文字まで入力可能です。');
    }
  });
}

// 物流担当者へのメモ (maxlength=53)
setupMaxLengthAlert('input[name="attributes[物流担当者へのメモ]"]', '物流担当者へのメモ');

// 送り状に記載するメモ (maxlength=100)
setupMaxLengthAlert('input[name="attributes[送り状に記載するメモ]"]', '送り状に記載するメモ');

// 貴社注文番号/現場名 (maxlength=30)
setupMaxLengthAlert('input[name="attributes[貴社注文番号/現場名]"]', '貴社注文番号/現場名');

// チェックアウトボタンを押したときの処理
document.getElementById('cart-checkout-button').addEventListener('click', (e) => {
  $('#cart-checkout-button-mask').show();
  $('#checkout-modal-cancel').prop('disabled', true);
  // submit時の前処理
  var inputVal = $('.remarks_memo').eq(0).val();

  // 文字列の頭に「新年度品　受注商品はまとめて同日に出荷してください。　」が含まれている場合
  if($('.remarks_memo').eq(0).val().indexOf("新年度品　受注商品はまとめて同日に出荷してください。　") == '0') {
    // 先頭の「新年度品　受注商品はまとめて同日に出荷してください。　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(27));
  }

  // 文字列の頭に「新年度品　」が含まれている場合
  if($('.remarks_memo').eq(0).val().indexOf("新年度品　") == '0') {
    // 先頭の「新年度品　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(5));
  }

  if($('.remarks_memo').eq(0).val().indexOf("受注商品はまとめて同日に出荷してください。　") == '0') {
    // 先頭の「受注商品はまとめて同日に出荷してください。　」を削除
    $('.remarks_memo').eq(0).val(inputVal.slice(22));
  }
  inputVal = $('.remarks_memo').eq(0).val();

  // 文言追加用変数
  var addStr = '';

  // 新年度品チェックボックスがonの場合
  if($('#new_year_product').prop('checked')) {
    // 「新年度品　」を追加
    addStr += '新年度品　';
  }

  // まとめ発送チェックボックスがonの場合
  if($('#collective_shipment').prop('checked')) {
    // 「受注商品はまとめて同日に出荷してください。　」を追加
    addStr += '受注商品はまとめて同日に出荷してください。　';
  }

  // 「物流担当者へのメモ」の文字列に文言追加
  $(".remarks_memo").eq(0).val(addStr + inputVal);

  // メールアドレス入力チェックでエラーメッセージがある場合はsubmitボタン押下時のイベントをキャンセルする
  // クラス名で検索してspan要素のテキストを抽出する
  let validateFlg = true;
  const spans =$('.mailAddressSpan');
  $.each(spans, function(index, span) {
    // テキストがある場合
    if(span.innerText !== "") {
      validateFlg = false;
      alert("メールアドレスの入力内容が正しくありません。");
      return false;
    }
  });

  // バリデーションエラーがある場合は処理を中止
  if(!validateFlg) {
    // イベント無効・伝播キャンセル
    e.preventDefault();
    e.stopPropagation();
    $('#cart-checkout-button-mask').hide();
    $('#checkout-modal-cancel').prop('disabled', false);
    return false;
  }

  // メールアドレス入力欄を取得
  const inputs = $('#contents-addresses').find('input[type="email"]');
  $.each(inputs, function(index, input) {
    const value = input.value;
    if (value == '') {
      // 空の入力欄は削除する
      input.remove();
    }
  });

  const customer_id = meta.page.customerId;
  const address_id = $('#shipping_address').val();
  // API送信
  const customerAccessToken = userState.getProperty('customer_access_token');
  const graphQL = new GraphQL();
  graphQL.customerDefaultAddressUpdate(address_id, customerAccessToken);

  // 下書き注文作成
  draftOrderCheckout(e);
}, false);

$('#cart-checkout-button-2').on('click', function(){
  const companyCodeWithName = $("#selected-customer").text();
  showCheckoutContent(companyCodeWithName);
});

$(document).ready(function () {
  // 選択中の得意先を画面に設定
  $("#hidden-attr-customer").val($("#selected-customer").text());

  // カレンダーの選択不可処理を行ったかのフラグ（複数回実行を防止する）
  let calendarMasked = false;
  // 日付入力欄を初期化したかのフラグ（入力後に初期化するのを防止する）
  let dateInitialized = false;
  // 日付入力欄のovserveの回数（2回目のときに初期値をセットしている）
  let observeCount = 0;
  // 表示されている納期リードタイムの最大を取得
  const leedtime = maxLeedtime();

  // カレンダーの表示/非表示を監視
  const datePicker = document.querySelector('.js-datePicker');
  const observerConfig = { attributes: true, childList: true, subtree: true };
  const observer = new MutationObserver(records => {
    // 変化が発生したときの処理を記述
    observer.disconnect(); // 監視を一時停止
    observeCount++;

    const calendar = document.querySelector('.react-date-picker__calendar');
    if (calendar && !calendarMasked) {
      // リードタイム分の日付を選択不可にする
      let day = new Date();
      for (let i = 0; i < leedtime; i++) {
        day.setDate( day.getDate() + 1);
        dayDisabled(calendar, day);
        calendarMoveCheck(calendar); // 選択可能な日付がなければ翌月に移動する
      }
      calendarMasked = true;
    }

    // 初期日付を空にする
    if (!dateInitialized && observeCount == 2 && getDateInput()) {
      clearCalendar();
      dateInitialized = true;
    }

    observer.observe(datePicker, observerConfig); // 監視を再開
  })
  observer.observe(datePicker, observerConfig);

  // 画面表示完了後は初期化フラグを強制的に立てる
  setTimeout(function() {
    dateInitialized = true;
  }, 2000);

});

// リードタイムの最大を取得する
function maxLeedtime() {
  const leedtimes = Array.from(document.querySelectorAll('[name="leedtime[]"]'));
  if (leedtimes.length > 0) {
    return leedtimes.reduce((max, leedtime) =>
    Number(leedtime.value) > max ? Number(leedtime.value) : max, Number(leedtimes[0].value)
    );
  } else {
    return 0;
  }
}

// 日付を選択不可にする
function dayDisabled(calendar, date, disabled = true) {
  const query = '[aria-label="' + dateFormat(date) + '"]';
  const day = calendar.querySelector(query);
  if (day) {
    day.parentElement.disabled = disabled;
  }
}

// 選択可能な日付があるかを確認し、なければ翌月に移動する（再帰的実行）
function calendarMoveCheck(calendar) {
  // 日付要素の取得
  const dayButton = calendar.querySelectorAll('button.react-calendar__month-view__days__day');
  const activeDay = Array.from(dayButton).filter((element) => {
    return element.disabled == false;
  });
  // 選択可能な日付がない場合
  if (activeDay.length == 0) {
    calendar.querySelector('.react-calendar__navigation__next-button').click(); // 翌月に移動
    calendar.querySelector('.react-calendar__navigation__prev-button').disabled = "true"; // 前月に戻るボタンを無効化
    calendarMoveCheck(calendar); // 再帰的実行
  }
}

// 日付入力欄の値の取得
function getDateInput() {
  const dateInput = document.querySelector('.react-date-picker__inputGroup');
  const attribute = document.querySelector('[name="attributes[delivery_date]"]');
  if (dateInput && attribute) {
    return attribute.value;
  } else {
    return false;
  }
}

// 日付入力とカレンダーの初期化
function clearCalendar() {
  const clearButton = document.querySelector('button.react-date-picker__clear-button.react-date-picker__button');
  clearButton.click();
  return;
}

// 日付のフォーマット
function dateFormat(date) {
  return date.getFullYear() + '年'
      +  (date.getMonth() + 1) + '月'
      +  date.getDate() + '日'
}


  } catch(e) { console.error(e); }
})();
})();
